// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__F_Ebm","container__heading":"styles_container__heading__982Ne","skeleton-animation":"styles_skeleton-animation__zNRI5"};